import { createMarketplaceEventFactory } from '../index';
import { MarketplaceAdminInteraction } from './interactions';

export const getMarketplaceAdminInteractionEvent =
  createMarketplaceEventFactory<MarketplaceAdminInteraction>(
    'Marketplace Admin',
    'Interaction'
  );
